<template>
  <general-item format="component">
    <span slot="title">{{ $t('edit.sidebar.in_one_component') }}</span>
    <span slot="description">{{ $t('edit.sidebar.one_component_to_integrate') }}</span>
  </general-item>
</template>

<script>
import GeneralItem from './GeneralItem';

export default {
  components: {
    GeneralItem,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Component.vue?4d051f46
 **/